import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { deleteItem } from '../api';

import { call, put } from 'redux-saga/effects';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processDelete(action: any) {
  // An uncaught rejection here ended the takeLatest watcher, so after one
  // failed delete no delete worked again until a reload — and the failure
  // itself was silent.
  try {
    yield call(deleteItem, action);
    yield put({ ...action, type: AT.ITEM_DELETE_DONE });
  } catch (e: any) {
    window.alert(
      e?.httpStatus === 501
        ? `Deleting a ${String(action.itemType).toLowerCase()} is not supported in this version.`
        : `Delete failed${e?.httpStatus ? ` (${e.httpStatus})` : ''}. Please try again.`
    );
    if (e?.httpStatus) yield put({ type: AT.HTTP_ERROR_SAGA, ...e });
  }
}

export default function* deleteItemSaga() {
  yield takeLatest(AT.DELETE_ITEM_SAGA, processDelete);
}
